<ng-container *ngIf="toasts.length > 0">
    <ngb-toast
        *ngFor="let toast of toasts"
        [header]="toast.header"
        [autohide]="true"
        [delay]="toast.delay || 5000"
        (hidden)="remove(toast)"
        >{{ toast.text }}</ngb-toast
    >
</ng-container>
